'use client';

import { memo } from 'react';

export type VersionBadgeProps = {
  /** The version number to display */
  version: number;
};

/**
 * Small badge displaying a version number (e.g., "V2").
 * Used in asset metadata panels and version selectors.
 */
export const VersionBadge = memo(({ version }: VersionBadgeProps) => {
  return (
    <span className="inline-flex items-center rounded-4 bg-neutral-4 px-1.5 py-0.5 font-semibold text-11 text-neutral-11">
      V{version}
    </span>
  );
});

VersionBadge.displayName = 'VersionBadge';
